import { render, staticRenderFns } from "./BulkInvoiceAdd.vue?vue&type=template&id=0624abd9&"
import script from "./BulkInvoiceAdd.vue?vue&type=script&lang=js&"
export * from "./BulkInvoiceAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports